import Model from '@/models/Model'
import ParagraphQuestionModel from '@/models/ParagraphQuestionModel'
import ParagraphVisualModel from '@/models/ParagraphVisualModel'
import ParagraphMarkerModel from '@/models/ParagraphMarkerModel'
import ParagraphKeyFigureModel from '@/models/ParagraphKeyFigureModel'
import ParagraphDYKTModel from '@/models/ParagraphDYKTModel'

export default class ParagraphModel extends Model {
  constructor (data, included = null) {
    super(data, included)
  }

  format (data, included, idx = 0) {
    if (idx > 10) return
    for (let key in data.relationships) {
      if (!ParagraphModel.ALLOW_RELATIONS.includes(key)) {
        continue
      }
      if (Array.isArray(data.relationships[key].data)) {
        if (data.rel === undefined) data.rel = {}

        data.rel[key] = data.relationships[key].data.map((d) => {
          const relation = this.getRelationShipsIncluded(included, d)
          if (relation) {
            try { return this.format(relation, included, idx + 1) } catch (e) { return null }
          } else { return null }
        })
      } else {
        const relation = this.getRelationShipsIncluded(included, data.relationships[key].data)

        if (relation) {
          if (data.rel === undefined) data.rel = {}
          try { data.rel[key] = this.format(relation, included, idx + 1) } catch (e) {}
        }
      }
    }
    return data
  }

  get title () {
    return this.get('attributes.title')
  }

  get description () {
    return this.get('attributes.description')
  }

  get type () {
    return this.get('type')
  }

  get questions () {
    const ps = this.get('rel.questions')
    if (!ps) return []
    return ps.map((p) => { return new ParagraphQuestionModel(p, this._included) })
  }

  get markers () {
    const ps = this.get('rel.markers')
    if (!ps) return []
    return ps.map((p) => { return new ParagraphMarkerModel(p, this._included) })
  }

  get keyFigures () {
    let keyFigures = this.get('rel.key_figures.data') || this.get('rel.key_figures')
    if (keyFigures) {
      keyFigures = keyFigures.map(kf => new ParagraphKeyFigureModel(kf || {}, this._included))
    }
    return keyFigures
  }

  // ParagraphVisuals
  get visuals () {
    let visuals = this.get('rel.visuals')
    if (visuals) {
      visuals = visuals.map(v => new ParagraphVisualModel(v, this._included))
    }
    return visuals
  }

  // ParagraphPortrait
  get visual () {
    return this.get('rel.visual.rel.field_image.links.picture_cover_desktop.href')
  }

  // ParagraphImageText
  get image () {
    return this.get('rel.image.attributes.url')
  }

  get derivatives () {
    return this.get('rel.image.links')
  }

  get alt () {
    return this.get('relationships.image.data.meta.alt')
  }

  // ParagraphSound
  get sound () {
    return this.get('rel.sound.rel.sound.attributes.url')
  }

  get soundURL () {
    return this.get('rel.sound.rel.sound.attributes.url')
  }

  get soundTitle () {
    return this.get('rel.sound.attributes.name')
  }

  // ParagraphFile
  get file () {
    return this.get('rel.file.attributes.url')
  }

  // ParagraphDrawers
  get drawers () {
    return this.get('rel.drawers')
  }

  // ParagraphSamples
  get samples () {
    return this.get('rel.samples')
  }

  // DidYouKnowThat
  get didYouKnowThat () {
    return new ParagraphDYKTModel(this._data, null)
  }
}

ParagraphModel.ALLOW_RELATIONS = ['type', 'samples', 'sample', 'visuals', 'visual', 'drawers', 'drawer', 'photos', 'field_image', 'file', 'sound', 'key_figures', 'markers', 'questions', 'media', 'image', 'thumbnail']
